import { Match, match, MatchFunction } from 'path-to-regexp';

import { plRouting } from '@onArte/shared/constants';
import { RouteNameEnum } from '@onArte/shared/enums';
import { RouteInfo } from '@onArte/shared/interfaces';

import { isKnownArtworkCategorySegment } from './artworkCategories.utils';

export function getRouteDetailsByName(routeName: RouteNameEnum): RouteInfo | undefined {
  return plRouting.find((route: RouteInfo) => route.name === routeName);
}

/**
 * Zwraca samą ścieżkę — bez parametrów zapytania i bez fragmentu.
 *
 * Wzorce tras w `plRouting` opisują wyłącznie ścieżkę, więc dopasowanie pełnego
 * adresu (np. `/dziela?page=1`) zawsze kończy się niepowodzeniem. Wywołania
 * z frontendu przekazują `location.pathname` i są bezpieczne, ale backend
 * przekazuje `request.url`, które parametry zawiera — i wtedy trasa nie zostaje
 * rozpoznana, a serwer odpowiada 404 z pustym tytułem.
 */
function getPathnameOnly(url: string): string {
  const pathname: string = url.split(/[?#]/)[0] ?? '';

  return pathname.length ? pathname : '/';
}

export function getRouteDetailsByUrl(url: string): RouteInfo | undefined {
  const pathname: string = getPathnameOnly(url);

  return plRouting
    .filter((route: RouteInfo): boolean => route.name !== RouteNameEnum.NotFound)
    .find((route: RouteInfo): boolean => {
      const urlMatch: MatchFunction<Record<string, string>> = match(route.url);
      const isMatched: Match<Record<string, string>> = urlMatch(pathname);

      if (!isMatched) {
        return false;
      }

      // Wzorzec /dziela/:category/:id dopasowałby DOWOLNE dwa segmenty, przez co
      // zmyślone adresy odpowiadałyby kodem 200 i kanonizowały same siebie.
      // Trasa istnieje wyłącznie dla czterech kategorii z umowy (poz. 13).
      return route.name !== RouteNameEnum.ArtworkDetailsInCategory
        || isKnownArtworkCategorySegment(isMatched.params.category ?? '');
    });
}
